import { render, staticRenderFns } from "./checklistRiskTab.vue?vue&type=template&id=62013d92"
import script from "./checklistRiskTab.vue?vue&type=script&lang=js"
export * from "./checklistRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62013d92')) {
      api.createRecord('62013d92', component.options)
    } else {
      api.reload('62013d92', component.options)
    }
    module.hot.accept("./checklistRiskTab.vue?vue&type=template&id=62013d92", function () {
      api.rerender('62013d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/risk/checklistRiskTab.vue"
export default component.exports